<template>
    <div
      class="popup-glass min-w-full min-h-full fixed top-0 left-0 z-50 overflow-hidden"
    >
      <div
        class="w-full min-h-full bg-white absolute top-0 right-0 md:w-1/3 p-4 md:p-6 md:pt-10 tooltip-window"
        ref="tooltipWindow"
      >
        <div class="flex items-center justify-between">
          <h3
            class="font-archivo font-bold text-primary-400 text-2xl"
            v-if="!isInstruction"
          >
            Model Answer
          </h3>
          <h3 class="font-archivo font-bold text-primary-400 text-2xl" v-else>
            Instruction
          </h3>
  
          <button class="" @click="emit('onCloseTooltip')">
            <svg
              class="w-7 h-7"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_1304_29357"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="48"
                height="48"
              >
                <rect width="48" height="48" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_1304_29357)">
                <path
                  d="M12.4501 37.6496L10.3501 35.5496L21.9001 23.9996L10.3501 12.4496L12.4501 10.3496L24.0001 21.8996L35.5501 10.3496L37.6501 12.4496L26.1001 23.9996L37.6501 35.5496L35.5501 37.6496L24.0001 26.0996L12.4501 37.6496Z"
                  class="fill-placeholder"
                />
              </g>
            </svg>
          </button>
        </div>
  
        <div class="md:flex flex-row-reverse md:px-1 gap-4 mt-4 md:mt-6">
          <div
            class="ml-auto min-h-10 min-w-10 h-10 w-10 md:min-h-20 md:min-w-20 md:h-20 md:w-20 rounded-full border-2 border-primary-400 bg-no-repeat bg-cover bg-top"
            :style="{ backgroundImage: `url('${characterImage}')` }"
          ></div>
          <div
            class="flex-1 bg-white rounded-md drop-shadow-md p-4 relative mt-2 md:mt-0"
            style="max-height: 775px; overflow-y: auto;"
          >
            <p class="font-epilogue font-bold text-primary-400 text-lg">
              {{ props.heading }}
            </p>
            <p
              class="text-gray-700 font-epilogue text-justify mt-1.5"
              v-html="tooltipText"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script setup>
  //v Vue Imports
  import { ref, onMounted, reactive, computed } from "vue";
  
  //v Vueuse Library
  import { onClickOutside } from "@vueuse/core";
  
  import characterImage from "@/assets/character-image.png";
  
  const props = defineProps({
    tooltip: {
      type: String,
    },
    heading: {
      type: String,
      default: "",
    },
    isInstruction: {
      type: Boolean,
      default: false,
    },
  });
  
  const tooltipHolder = ref("");
  
  const tooltipText = ref(``);
  
  //v Mock robot text on  mounted
  let interval = ref(null);
  onMounted(() => {
    tooltipHolder.value = props.tooltip;
  
    interval.value = setInterval(() => {
      if (tooltipHolder.value.length != 0) {
        tooltipText.value += [...tooltipHolder.value].shift();
        tooltipHolder.value = tooltipHolder.value.substring(1);
      } else {
        window.clearInterval(interval.value);
      }
    }, 10);
  });
  
  const tooltipWindow = ref(null);
  
  onClickOutside(tooltipWindow, () => {
    emit("onCloseTooltip");
  });
  
  const emit = defineEmits(["onCloseTooltip"]);
  </script>
  <style scoped>
  .popup-glass {
    background-image: linear-gradient(
      240deg,
      hsla(174, 66%, 15%, 0.512) 0%,
      hsla(173, 71%, 19%, 0.528) 7%,
      hsla(172, 77%, 22%, 0.51) 15%,
      hsla(172, 83%, 25%, 0.506) 28%,
      hsla(172, 90%, 28%, 0.486) 48%,
      hsla(172, 100%, 31%, 0.491) 63%,
      hsla(171, 56%, 42%, 0.471) 73%,
      hsla(172, 42%, 49%, 0.444) 81%,
      hsla(174, 41%, 55%, 0.416) 88%,
      hsla(176, 42%, 60%, 0.36) 94%,
      hsla(179, 45%, 66%, 0.415) 100%
    );
  
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
  }
  
  .tooltip-window {
    animation: move-in 0.8s ease forwards;
  }
  
  @keyframes move-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
  </style>
  